import React from 'react';
import Hero from '../Hero/Hero.component';
import Services from '../Services/Services.component';
import About from '../About/About.component';
import Gallery from '../Gallery/Gallery.component';
import Contact from '../Contact/Contact.component';
import GoogleReviews from '../GoogleReviews/GoogleReviews.component';

const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <About />
      <Gallery />
      <Contact />
      <GoogleReviews />
    </>
  );
};

export default Home;

